// extracted by mini-css-extract-plugin
export default {"wrapper":"d0-z","play":"e0-z"};